// extracted by mini-css-extract-plugin
module.exports = {"editorWrap":"RichTextEditor_editorWrap__3rWe-"};